"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WpCNPTransactionEventDataContract = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const enums_1 = require("../../../../global/enums");
class WpCNPTransactionEventDataContract {
}
exports.WpCNPTransactionEventDataContract = WpCNPTransactionEventDataContract;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)()
], WpCNPTransactionEventDataContract.prototype, "isCNP", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)()
], WpCNPTransactionEventDataContract.prototype, "isTransactionApproved", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)()
], WpCNPTransactionEventDataContract.prototype, "isCVVValid", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)()
], WpCNPTransactionEventDataContract.prototype, "isAVSValid", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)()
], WpCNPTransactionEventDataContract.prototype, "paymentId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)()
], WpCNPTransactionEventDataContract.prototype, "transactionId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((params) => params.value.toString())
], WpCNPTransactionEventDataContract.prototype, "wpTransactionNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(enums_1.ExpressResponseCodes)
], WpCNPTransactionEventDataContract.prototype, "responseCode", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)()
], WpCNPTransactionEventDataContract.prototype, "accountNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)()
], WpCNPTransactionEventDataContract.prototype, "approvedAmount", void 0);
//# sourceMappingURL=WpCNPTransactionEventDataContract.js.map